var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasNoResult || !_vm.hideNoResult)?_c('trax-ui-card-result',{attrs:{"background-color":_vm.backgroundColor,"title":_vm.title,"result":_vm.result,"result-size":_vm.resultSize}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }